import { EspAccount } from 'modules/graphql/types';
import { DestructiveButton, BUTTON_SIZES } from 'ui/button';
import { Modal, ModalFooter, ModalBody, ModalHeader, MODAL_SIZES, MODAL_VARIANTS } from 'ui/modal';
import { Body2 } from 'ui/theme';
import { useModalsContext, useSendingPlatformsQueryContext } from '../../../contexts';
import { useDeleteAccount } from '../../../hooks';
import { DeleteEspAccountPayload } from '../../../types';

export const TEXT = {
  ID: 'edit-account-integration-modal',
  HEADER: 'Disconnect account?',
  CONFIRM_BUTTON: 'Disconnect account',
};

export const bodyText = (name: string) =>
  `If you proceed, we’ll disconnect the ${name} account from your Iterable project. If you want to send from this account again, you can set it up again in the future.`;

type Props = {
  espAccountId: number;
};

export const DisconnectAccountModal = ({ espAccountId }: Props) => {
  const { hideModal } = useModalsContext();
  const { selectEspAccount } = useSendingPlatformsQueryContext();
  const deleteAccount = useDeleteAccount();

  const espAccount = selectEspAccount(espAccountId) as EspAccount;
  const { esp } = espAccount;

  const onSubmit = () => {
    const payload: DeleteEspAccountPayload = { id: espAccountId };
    deleteAccount(payload);
    hideModal();
  };

  return (
    <Modal
      id={TEXT.ID}
      isModalOpen={true}
      onClose={hideModal}
      size={MODAL_SIZES.SMALL}
      variant={MODAL_VARIANTS.DELETE}
    >
      <ModalHeader>{TEXT.HEADER}</ModalHeader>
      <ModalBody>
        <Body2>{bodyText(esp)}</Body2>
      </ModalBody>
      <ModalFooter>
        <DestructiveButton onClick={onSubmit} size={BUTTON_SIZES.LARGE}>
          {TEXT.CONFIRM_BUTTON}
        </DestructiveButton>
      </ModalFooter>
    </Modal>
  );
};
